import React, { useContext } from "react";
import styled from "styled-components";
import { MenuContext } from "../context/context";

const HamburgerContainer = styled.div`
  display: none;
  color: var(--white);
  height: 50%;
  width: 2.2rem;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 868px) {
    display: flex;
    margin-right: 50px;
  }
  @media (max-width: 576px) {
    margin-right: 30px;
  }
`;

const Icon = styled.span`
  position: relative;
  background-color: ${(props) =>
    props.clicked === true ? "transparent" : props.color};
  width: 75%;
  height: 1.3px;
  display: inline-block;
  transition: all 0.3s;
  &::before,
  &::after {
    background-color: ${(props) => props.color};
    content: "";
    width: 100%;
    height: 1.3px;
    display: inline-block;
    position: absolute;
    left: 0;
    transition: all 0.3s;
  }

  &::before {
    top: ${(props) => (props.clicked === true ? "0" : "-0.5rem")};
    transform: ${(props) =>
      props.clicked === true ? "rotate(135deg)" : "rotate(0)"};
  }
  &::after {
    top: ${(props) => (props.clicked === true ? "0" : "0.5rem")};
    transform: ${(props) =>
      props.clicked === true ? "rotate(-135deg)" : "rotate(0)"};
  }
`;

const BarsMenu = (props) => {
  const ctx = useContext(MenuContext);

  return (
    <HamburgerContainer onClick={ctx.toggleMenu}>
      <Icon clicked={ctx.isMenuOpen} color={props.color}></Icon>
    </HamburgerContainer>
  );
};

export default BarsMenu;
